// Private variables
let _api;

function RecipeListsService(restangular) {
    _api = restangular.all('recipes/lists');

    this.loadingCount = true;
}

RecipeListsService.prototype.getSavedRecipes = function (pageSize, pageNumber, sortType) {
    return _api.doGET('', {
        pageSize,
        pageNumber,
        sortType,
    }).then((response) => {
        this.loadingCount = false;
        this.keptRecipesCount = response.TotalRecordCount;
        return {
            items: response.Items,
            totalRecordCount: response.TotalRecordCount,
        };
    });
};

RecipeListsService.prototype.initialiseCountForGuestUser = function () {
    this.keptRecipesCount = 0;
    this.loadingCount = false;
};

RecipeListsService.prototype.removeSavedRecipe = function (recipeId) {
    // ideally this will be a delete verb but IIS6...
    return _api.doPOST({ Id: recipeId }).then(() => {
        this.keptRecipesCount--;
    });
};

RecipeListsService.prototype.saveRecipeToList = function (recipeId) {
    return _api.get(recipeId).then(() => {
        this.keptRecipesCount++;
    });
};

module.exports = RecipeListsService;



// WEBPACK FOOTER //
// ./src/recipe/recipe-savedList/recipe-savedList.service.js